import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';

import {
  CommercialOfferCardPage,
  ICommercialOfferCardPageDispatchProps,
  ICommercialOfferCardPageProps,
  ICommercialOfferCardPageStoreProps,
} from './index';

import { setKeyPushNotificationValue } from '../../store/push_subscription';
import { fetchAgent } from '../../store/offer';

function mapStateToProps(state: IState): ICommercialOfferCardPageStoreProps {
  return {
    offer: state.offerData.offer,
    degradationInfo: state.offerData.degradationInfo,
  };
}

function mapDispatchToProps(dispatch: Dispatch<IState>): ICommercialOfferCardPageDispatchProps {
  return {
    fetchAgent: () => dispatch(fetchAgent()),
    setKeyPushNotificationValue: (value: boolean) => dispatch(setKeyPushNotificationValue(value)),
  };
}

export const CommercialOfferCardPageContainer = connect<ICommercialOfferCardPageStoreProps,
  ICommercialOfferCardPageDispatchProps,
  ICommercialOfferCardPageProps>(mapStateToProps, mapDispatchToProps)(CommercialOfferCardPage);
